import * as React from 'react'
import {translateCountryName, formatDate} from "@ui-seeker/utils";

import {LabelCountry} from "@components";
import {BACKEND_APIS} from "@constants";
import { RetailerBlock } from '@components';


export default function retailerColumn() {
	return [{
		name: 'date', label: 'Date',
		options: {
			display: 'excluded',
			customBodyRowRender: value => formatDate(value, { isString: true })
		}
	},{
		name: 'country', label: 'Country',
		options: {
			display: 'excluded',
			customBodyRowRender: value => translateCountryName(value)
		}
	}, {
		name: 'retailer', label: 'Retailer',
		options: {
			headerAlign: 'left',
			customBodyRowRenderLite: (value, { country, siteID, productID, date, siteURL }) => <RetailerBlock
				retailer={value}
				country={country}
				siteURL={siteURL}
			/>
		}
	}]
}